<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { RepositoryFactory } from '../data/repositoryFactory';
import { generateActionsReport } from '../helpers/actions/actionsRegisterReportGeneratorHelper.js';

const RepositoryActions = RepositoryFactory.get('actions');
const route = useRoute();
const isLoading = ref(false);

function generateActionsRegisterReport() {
  isLoading.value = true;

  RepositoryActions.getActionsRegisterRaportContentByUUID(route.params.uuid)
    .then((data) => {
      generateActionsReport(data, 'Rejestr akcji');
    })
    .catch((error) => console.log(error))
    .finally(() => {
      isLoading.value = false;
    });
}

onMounted(() => {
  generateActionsRegisterReport();
});
</script>

<template>
  <div class="ibox">
    <div
      class="ibox-content"
      :class="{ 'sk-loading': isLoading }"
      style="border-style: none; height: 100px"
    >
      <div class="sk-spinner sk-spinner-three-bounce">
        <div class="sk-bounce1"></div>
        <div class="sk-bounce2"></div>
        <div class="sk-bounce3"></div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
